import pwaConfigStatic from '../../../../static/pwa-config.json'
import pwaConfigGPAYStatic from '../../../../static/pwa-config-GPAY.json';
import pwaConfigPAYTMStatic from '../../../../static/pwa-config-PAYTM.json';
import appConfigStatic from '../../../../static/app-config.json';
import appConfigGPAYStatic from '../../../../static/app-config-GPAY.json';
import appConfigPAYTMStatic from '../../../../static/app-config-PAYTM.json';
import { keyMapsAction, keyMapsMutation } from '../../helpers/storeKeys';
import localStorageFunc from "../../helpers/localStorageFunc";
import get from 'lodash/get';
import Utility from '../../helpers/utility';

const initialConfig = (store) => {
	const userInfo = localStorageFunc.getUserData();
	const sessionToken = get(userInfo, "headers.credentials.sessionToken", null);
	const refreshToken = get(userInfo, "headers.credentials.refreshToken", null);
	if (!sessionToken && !refreshToken) {
		store.dispatch(keyMapsAction.ANONYMOUS_USER_API);
	}
	const [pwaConfigObj, appConfigObj] = Utility.checkIfIsGpay() ?
		[pwaConfigGPAYStatic, appConfigGPAYStatic] :
		Utility.checkIfIsPAYTM() ?
		[pwaConfigPAYTMStatic, appConfigPAYTMStatic] :
		[pwaConfigStatic, appConfigStatic];
	store.commit(keyMapsMutation.UPDATE_PWA_CONFIG, pwaConfigObj, { root: true });
	store.commit(keyMapsMutation.UPDATE_APP_CONFIG, appConfigObj, { root: true });
	store.dispatch('Config/getPWAConfig', {}, {root: true});
  	store.dispatch('Config/getAppConfig', {}, {root: true});
};

export default initialConfig;
